import { render } from "./StandardCircleWhiteIcon.vue?vue&type=template&id=2608f0f7"
import script from "./StandardCircleWhiteIcon.vue?vue&type=script&lang=js"
export * from "./StandardCircleWhiteIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__